export class SiteDetail {
  roles = new Set<string>()
  static getCookieMap (): Map<string, string> {
    const ret = new Map<string, string>()
    const cookies = document.cookie.split(';')
    cookies.forEach((c) => {
      const kv = c.split('=')
      if (kv.length >= 2) {
        ret.set(kv[0].trim(), kv[1].trim())
      }
    })
    return ret
  }

  isProfilePage = false
  isRegisterPage = false
  isActivatePage = false
  isIframe = false
  isPPBrand = false

  constructor () {
    const cookies = SiteDetail.getCookieMap()
    this.roles = new Set<string>((cookies.get('ssoroles') || '').split(',').filter((x) => x.length !== 0))
    this.isProfilePage = (window.location.pathname.indexOf('/profile') === 0)
    this.isRegisterPage = (window.location.pathname.indexOf('/register') === 0)
    this.isActivatePage = (window.location.pathname.indexOf('/activate') === 0)
    this.isIframe = window.self !== window.top
    this._loadRoleTemplates()
    if (this.isRegisterPage) {
      this.showActivate = this.showProfile = this.showAdminPortal = this.showCustomerPortal = false
      this.showRegister = true
    } else if (this.isProfilePage || this.isIframe) {
      this.showActivate = this.showRegister = this.showAdminPortal = this.showCustomerPortal = false
      this.showProfile = true
    } else if (this.isActivatePage) {
      this.showRegister = this.showProfile = this.showAdminPortal = this.showCustomerPortal = false
      this.showActivate = true
    } else if (this.roles.size === 0) {
      // This page requires auth, but no roles detected, force login
      console.log('No roles detected, forcing signin')
      window.location.pathname = '/login'
    }
  }

  showAdminPortal = false
  showCustomerPortal = false
  showProfile = false
  showRegister = false
  showActivate = false
  adminReadwrite = false
  adminSuperuser = false
  userReadwrite = false

  private _hasAnyRole (roles: Array<string>) {
    for (const r of roles) {
      if (this.roles.has(r)) return true
    }
    return false
  }

  private _loadRoleTemplates () {
    this.showAdminPortal = this._hasAnyRole(['sso_admin_readonly', 'sso_admin_readwrite', 'sso_admin_superuser'])
    this.adminReadwrite = this._hasAnyRole(['sso_admin_readwrite', 'sso_admin_superuser'])
    this.adminSuperuser = this._hasAnyRole(['sso_admin_superuser'])
    this.userReadwrite = this.adminReadwrite
  }
}

const Site = new SiteDetail()

export default Site
